var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tooltip",
    {
      attrs: {
        trigger: "click",
        content: _vm.$t("MESSAGES.COPIED"),
        color: _vm.color,
        background: _vm.background
      },
      on: { click: _vm.copyLink }
    },
    [
      _c("channel", {
        attrs: {
          type: "link",
          color: _vm.color,
          background: _vm.background,
          filled: _vm.hover
        },
        nativeOn: {
          mouseover: function($event) {
            _vm.hover = true
          },
          mouseleave: function($event) {
            _vm.hover = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }